import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BeUsuario } from 'src/app/models/BeUsuario';
import { ActivatedRoute, Router } from '@angular/router';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AuthService } from 'src/app/services/auth.service';
import { TokenService } from 'src/app/services/token.service';
import { LevelPte } from 'src/app/app-config';

@Component({
  selector: 'app-create-usuario',
  templateUrl: './create-usuario.component.html',
  styleUrls: ['./create-usuario.component.css']
})
export class CreateUsuarioComponent implements OnInit, OnDestroy {
  public hide = true;
  public subscription?: Subscription;
  public createFormGroup: FormGroup;
  public exibeCamposEasyMob = false;

  private createIdUsuarioFormControl = new FormControl<number | null>(null);
  private createNoNomeCompletoFormControl = new FormControl<string | null>(null, [Validators.required, Validators.minLength(5)]);
  private createNoCpfjFormControl = new FormControl<string | null>(null, [Validators.required, Validators.minLength(11)]);
  private createNoSenhaFormControl = new FormControl<string | null>(null, [Validators.required, Validators.minLength(5)]);
  private createNoEmailFormControl = new FormControl<string | null>(null, [Validators.required, Validators.minLength(5)]);
  private createNrCelularFormControl = new FormControl<string | null>(null);
  private createNoEasyMobChaveFormControl = new FormControl<string | null>(null);
  private createNoEasyMobUsuarioFormControl = new FormControl<string | null>(null);
  private createNoEasyMobSenhaFormControl = new FormControl<string | null>(null);

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
    private tokenService: TokenService
  ) {
    this.createFormGroup = new FormGroup({
      idUsuario: this.createIdUsuarioFormControl,
      noNomeCompleto: this.createNoNomeCompletoFormControl,
      noSenha: this.createNoSenhaFormControl,
      noCpfj: this.createNoCpfjFormControl,
      noEmail: this.createNoEmailFormControl,
      nrCelular: this.createNrCelularFormControl,
      noEasyMobChave: this.createNoEasyMobChaveFormControl,
      noEasyMobUsuario: this.createNoEasyMobUsuarioFormControl,
      noEasyMobSenha: this.createNoEasyMobSenhaFormControl,
    });
  }

  public ngOnInit(): void {
    this.sub.clear();
    this.createIdUsuarioFormControl.setValue(null);
    this.createNoNomeCompletoFormControl.setValue(null);
    this.createNoSenhaFormControl.setValue(null);
    this.createNoCpfjFormControl.setValue(null);
    this.createNoEmailFormControl.setValue(null);
    this.createNrCelularFormControl.setValue(null);
    this.createNoEasyMobChaveFormControl.setValue(null);
    this.createNoEasyMobUsuarioFormControl.setValue(null);
    this.createNoEasyMobSenhaFormControl.setValue(null);
    this.carregarPermissaoEasyMob();
    this.unsubscribe();
  }

  private carregarPermissaoEasyMob(): void {
    this.tokenService
      .getTokenUserCredentials()
      .subscribe((token) =>
        this.tokenService
          .decodeToken(token)
          .subscribe((authToken) => {
            this.exibeCamposEasyMob = AuthService.canTokenActivate(authToken, LevelPte);
          })
      );
  }

  public ngOnDestroy(): void {
    this.sub.clear();
    this.unsubscribe();
  }

  public onSalvar() {
    this.unsubscribe();
    const payload = { ...this.createFormGroup.value };
    if (payload.nrCelular) {
      payload.nrCelular = payload.nrCelular.replace(/\D/g, '');
    }
    this.subscription = this.httpClient.post<BeUsuario>(
      `/api/Usuarios`, payload
    ).subscribe({
      next: () => {
        this.unsubscribe();
        this.snackBarService.exibirSucesso('Registro criado!');
        this.router.navigate(['/usuarios'], { relativeTo: this.route });
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }
  
  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

}
